export const colorsChartTheme7 = {
    goals: {
        medium: { light: "rgba(6, 50, 84, 1)", dark: "rgba(244, 244, 244, 1)" }
    },
    cyan: {
        dark: {
            light: "rgba(212, 120, 108, 1)",
            dark: "rgba(237, 155, 145, 1)"
        },
        medium: {
            light: "rgba(223, 153, 144, 1)",
            dark: "rgba(247, 193, 186, 1)"
        },
        light: {
            light: "rgba(237, 197, 192, 1)",
            dark: "rgba(255, 235, 232, 1)"
        },
        darker: {
            light: "rgba(190, 71, 55, 1)",
            dark: "rgba(217, 100, 85, 1)"
        },
        lighter: {
            light: "rgba(237, 197, 192, 1)",
            dark: "rgba(255, 235, 232, 1)"
        },
        disabled: {
            light: "rgba(237, 197, 192, 1)",
            dark: "rgba(255, 235, 232, 1)"
        }
    },
    purple: {
        medium: {
            light: "rgba(62, 146, 204, 1)",
            dark: "rgba(92, 173, 229, 1)"
        },
        darker: {
            light: "rgba(26, 67, 97, 1)",
            dark: "rgba(45, 90, 122, 1)"
        },
        dark: {
            light: "rgba(34, 89, 129, 1)",
            dark: "rgba(56, 114, 156, 1)"
        },
        light: {
            light: "rgba(78, 154, 208, 1)",
            dark: "rgba(113, 184, 235, 1)"
        },
        lighter: {
            light: "rgba(174, 209, 234, 1)",
            dark: "rgba(214, 238, 255, 1)"
        }
    },
    yellow: {
        light: {
            light: "rgba(171, 144, 182, 1)",
            dark: "rgba(200, 184, 207, 1)"
        },
        medium: {
            light: "rgba(128, 94, 143, 1)",
            dark: "rgba(156, 128, 168, 1)"
        },
        dark: {
            light: "rgba(128, 94, 143, 1)",
            dark: "rgba(156, 128, 168, 1)"
        },
        darker: {
            light: "rgba(128, 94, 143, 1)",
            dark: "rgba(156, 128, 168, 1)"
        }
    },
    violet: {
        lighter: {
            light: "rgba(171, 201, 3, 1)",
            dark: "rgba(196, 227, 25, 1)"
        },
        "lighter-weight": {
            light: "rgba(206, 241, 4, 1)",
            dark: "rgba(222, 255, 31, 1)"
        },
        light: {
            light: "rgba(137, 161, 2, 1)",
            dark: "rgba(161, 186, 20, 1)"
        },
        "light-weight": {
            light: "rgba(154, 181, 3, 1)",
            dark: "rgba(179, 207, 25, 1)"
        },
        medium: {
            light: "rgba(137, 155, 34, 1)",
            dark: "rgba(143, 166, 18, 1)"
        },
        dark: {
            light: "rgba(86, 100, 2, 1)",
            dark: "rgba(109, 125, 15, 1)"
        },
        darker: {
            light: "rgba(69, 80, 1, 1)",
            dark: "rgba(92, 105, 11, 1)"
        }
    },
    magenta: {
        medium: {
            light: "rgba(191, 91, 4, 1)",
            dark: "rgba(217, 115, 26, 1)"
        },
        light: {
            light: "rgba(214, 123, 43, 1)",
            dark: "rgba(214, 123, 43, 1)"
        },
        lighter: {
            light: "rgba(222, 146, 80, 1)",
            dark: "rgba(222, 146, 80, 1)"
        }
    },
    gray: {
        medium: {
            light: "rgba(206, 215, 222, 1)",
            dark: "rgba(218, 227, 235, 1)"
        }
    },
    basic: {
        medium: {
            light: "rgba(157, 176, 190, 1)",
            dark: "rgba(193, 200, 205, 1)"
        },
        dark: {
            light: "rgba(157, 176, 190, 1)",
            dark: "rgba(193, 200, 205, 1)"
        }
    },
    black: {
        petroleum: {
            light: "rgba(157, 176, 190, 1)",
            dark: "rgba(193, 200, 205, 1)"
        }
    }
};
